import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { putStream } from '../../../api/streams';

import { mergeStreamWithUserData } from '../../../utils/streams';
import { generateStreamCIDKey } from '../../../components/Streams/utils/generateStreamCIDKey';
import { REQUEST } from '../../../constants/request';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

export const updateStream = createAsyncThunk(
  `streams/updateStream`,
  async (streamData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [streamResponse, streamUserDataResponse] = await putStream(
        streamData,
        {
          cancelToken: source.token,
        },
      );
      return mergeStreamWithUserData(streamResponse, streamUserDataResponse);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: ({ path: { orgId, streamId } }, { getState }) => {
      const streamCIDKey = generateStreamCIDKey({ orgId, streamId });
      const { streams } = getState().streams;

      return (
        streams.stream.actions.update.request[streamCIDKey]?.loading !==
        REQUEST.pending
      );
    },
  },
);

export const updateStreamExtraReducers = builder => {
  builder
    .addCase(updateStream.pending, (state, action) => {
      const streamCIDKey = generateStreamCIDKey(action.meta.arg.path);

      checkAndSetLoadingWithId(
        state.streams.stream.actions.update.request,
        action,
        streamCIDKey,
      );
    })
    .addCase(updateStream.fulfilled, (state, action) => {
      const streamCIDKey = generateStreamCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.streams.stream.actions.update.request[streamCIDKey],
        action,
        () => {
          state.streams.stream.byId[streamCIDKey] = { ...action.payload };

          if (!state.streams.stream.allIds.includes(streamCIDKey)) {
            state.streams.stream.allIds.push(streamCIDKey);
          }
        },
      );
    })
    .addCase(updateStream.rejected, (state, action) => {
      handleRequestRejection(
        state.streams.stream.actions.update.request[
          generateStreamCIDKey(action.meta.arg.path)
        ],
        action,
      );
    });
};
